import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
const CALENDAR_URL = 'https://calendar.app.google/PYPdcRoYne7QrNJA7';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const bullets = ['Si recibes llamadas de personas que quieren consulta gratis pero no pueden pagar el retainer', 'Si tus competidores aparecen primero en Google aunque no sean mejores que tú', 'Si dependes de referidos para crecer y no tienes un sistema predecible de clientes nuevos cada mes', 'Si tienes presencia en redes sociales pero no genera casos reales', 'Si eres experto en Inmigración, Accidentes, Familia o Criminal pero el mercado no lo sabe'];
  return <section className="min-h-screen flex items-center justify-center pt-20 pb-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-21">
      {/* Subtle background glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-22" />

      <div className="max-w-4xl mx-auto relative z-10 w-full" data-id="element-23">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-col items-center text-center" data-id="element-24">
          <motion.h1 variants={itemVariants} className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-gold leading-tight mb-6" data-id="element-25">
            ¿Pasando horas en consultas gratuitas con personas que no pueden
            pagar tus honorarios?
          </motion.h1>

          <motion.p variants={itemVariants} className="font-body text-lg sm:text-xl text-gray-300 max-w-3xl mb-12 leading-relaxed" data-id="element-26">
            Implementamos un sistema de captación que filtra y pre-califica a
            los prospectos antes de que lleguen a tu agenda. Solo hablas con
            clientes que ya confían en tu firma y tienen el presupuesto para
            contratar tus servicios.
          </motion.p>

          <motion.div variants={itemVariants} className="w-full max-w-2xl text-left mb-12 bg-[#111] border border-white/5 rounded-2xl p-6 sm:p-8 shadow-2xl" data-id="element-27">
            <ul className="space-y-4" data-id="element-28">
              {bullets.map((bullet, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-3" data-id="element-29">
                  <AlertCircleIcon className="w-6 h-6 text-gold shrink-0 mt-0.5" aria-hidden="true" data-id="element-30" />
                  <span className="font-body text-gray-200 text-base sm:text-lg leading-snug" data-id="element-31">
                    {bullet}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div variants={itemVariants} className="flex flex-col items-center w-full" data-id="element-32">
            <a href={CALENDAR_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-lg sm:text-xl font-bold text-carbon bg-gold hover:bg-gold-light transition-colors duration-300 rounded-lg shadow-[0_0_20px_rgba(242,183,5,0.3)] hover:shadow-[0_0_30px_rgba(242,183,5,0.5)] focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-carbon" data-id="element-33">
              QUIERO CASOS CALIFICADOS
            </a>
            <p className="mt-4 font-body text-sm text-gray-400" data-id="element-34">
              Diagnóstico de tu firma en 15 minutos.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}